import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const Header = ({ appMode, onModeChange, currentUserId, isAuthenticated, userName, onLogout }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-md sticky top-0 z-40 border-b">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/marketplace')}>
          <h1 className="text-3xl font-bold">
            <span className="text-gray-800">Flippy</span>{' '}
            <span className="text-emerald-600">Homes</span>
            <span className="text-sm text-gray-500 ml-1">.co.za</span>
          </h1>
        </div>
        
        <div className="flex items-center gap-4 text-xs">
          {isAuthenticated && (
            <>
              <div className="flex items-center gap-2 bg-emerald-50 px-4 py-2 rounded-lg border border-emerald-200">
                <i className="fas fa-user-circle text-emerald-600 text-lg"></i>
                <div>
                  <p className="text-xs text-gray-600">Logged in as</p>
                  <p className="font-semibold text-emerald-700">{appMode}</p>
                </div>
              </div>
              
              <div className="text-sm text-gray-600 hidden sm:block">
                <span className="font-semibold">{userName}</span>
              </div>

              <Button 
                variant="outline" 
                size="sm"
                onClick={onLogout}
                data-testid="logout-btn"
                className="hover:bg-red-50 hover:text-red-600 hover:border-red-200"
              >
                <i className="fas fa-sign-out-alt mr-2"></i> Logout
              </Button>
            </>
          )}

          {!isAuthenticated && (
            <Button 
              onClick={() => navigate('/auth')}
              className="bg-emerald-600 hover:bg-emerald-700"
              data-testid="login-btn"
            >
              <i className="fas fa-sign-in-alt mr-2"></i> Login / Register
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;